<template>
  <div class="list-item-container d-flex flex-column">
    <div class="search media">
      <div class="media-body">
        <search-input @search="searchHome"></search-input>
      </div>
    </div>
    <div class="home-list">
      <div class="create-category">
        <div>+ เพิ่มหมวดหมู่</div>
        <div>
          <el-input
            v-model="categoryName"
            type="text"
            placeholder="ตั้งชื่อหมวดหมู่ที่ต้องการ"
          ></el-input>
        </div>
        <label class="select-input">
          <span>มีผลกับแอพฯ</span>
          <input v-model="isAffectApp" :value="true" type="radio" disabled />
          <span class="checkmark radio"></span>
        </label>
        <label class="select-input">
          <span>ไม่มีผลกับแอพฯ</span>
          <input v-model="isAffectApp" :value="false" type="radio" />
          <span class="checkmark radio"></span>
        </label>
        <div class="submit-category">
          <sc-button size="sm" variant="warning" @click="handleSaveCategory"
            >บันทึก</sc-button
          >
        </div>
      </div>
      <div>
        <div class="group-category d-flex px-3 py-3">กลุ่มมีผลกับแอปฯ</div>
        <router-link
          v-for="item in listAffectApp"
          :key="item.id"
          v-slot="{ navigate, isActive }"
          :to="item.route"
          active-class="active"
          custom
        >
          <div
            :class="{ active: isActive }"
            class="home-item d-flex px-3 py-3"
            @click="navigate"
          >
            <div class="flex-grow-1 flex-shrink-0">
              <h5 class="home-number">{{ item.name }}</h5>
            </div>
          </div>
        </router-link>
      </div>
      <div>
        <div class="group-category d-flex px-3 py-3">กลุ่มไม่มีผลกับแอปฯ</div>
        <router-link
          v-for="item in listNotAffectApp"
          :key="item.id"
          v-slot="{ navigate, isActive }"
          :to="item.route"
          active-class="active"
          custom
        >
          <div
            :class="{ active: isActive }"
            class="home-item d-flex px-3 py-3"
            @click="navigate"
          >
            <div class="flex-grow-1 flex-shrink-0">
              <h5 class="home-number">{{ item.name }}</h5>
            </div>
          </div>
        </router-link>
      </div>
      <div>
        <div class="group-category d-flex px-3 py-3">กลุ่มที่ถูกยกเลิก</div>
        <router-link
          v-for="item in listCancelNotAffectApp"
          :key="item.id"
          v-slot="{ navigate, isActive }"
          :to="item.route"
          active-class="active"
          custom
        >
          <div
            :class="{ active: isActive }"
            class="home-item d-flex px-3 py-3"
            @click="navigate"
          >
            <div class="flex-grow-1 flex-shrink-0">
              <h5 class="home-number">{{ item.name }}</h5>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import SearchInput from "@/components/helper/SearchInput"
import { isEmpty } from "ramda"
import ScButton from "@/lib/components/ScButton"
import { Input } from "element-ui"

export default {
  components: {
    SearchInput,
    "el-input": Input,
    ScButton,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    deletedAt: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      searchKeyword: "",
      categoryName: null,
      isAffectApp: false,
    }
  },
  computed: {
    listAffectApp() {
      return this.applySearch(
        this.value.filter((item) => item.isAffectApp === true),
      )
    },
    listNotAffectApp() {
      return this.applySearch(
        this.value.filter(
          (item) => item.isAffectApp === false && !item.deletedAt,
        ),
      )
    },
    listCancelNotAffectApp() {
      return this.applySearch(this.value.filter((item) => item.deletedAt))
    },
  },
  methods: {
    applySearch(list) {
      if (isEmpty(this.searchKeyword)) return list

      const keyword = this.searchKeyword.toLowerCase()

      return list.filter((item) => item.name.toLowerCase().includes(keyword))
    },
    searchHome(keyword) {
      this.searchKeyword = keyword
    },
    handleSaveCategory() {
      if (!this.categoryName) {
        this.$message.error("กรุณาใส่ชื่อหมวดหมู่")
        return
      }

      const newCategory = {
        category_name: this.categoryName,
        is_affect_app: this.isAffectApp,
        deleted_at: this.deletedAt,
      }

      this.$emit("createCategory", newCategory)
      this.categoryName = null
      this.isAffectApp = false
    },
  },
}
</script>

<style lang="scss" scoped>
.search {
  border-bottom: 1px solid #e0e0e0;
  padding: 15px;
}
.list-item-container {
  background: white;
  border-right: solid 1px #e0e0e0;
  padding: 0;
}
.home-list {
  overflow: auto;
}

.home-item {
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  overflow-x: auto;

  &:hover {
    background: #f9f9f9;
  }
  &.active {
    background: #efefef;
  }
  .home-number-label {
    font-size: 11px;
    color: #8c8786;
  }
  h5.home-number {
    color: black;
    font-size: 18px;
    font-weight: bold;
  }
  .member-status {
    border-radius: 5px;
    background-color: #f9f9f9;
    padding: 8px;
    .label {
      font-size: 11px;
    }
    .info {
      font-weight: bold;
      font-size: 14px;
      color: #8c8786;
    }
    &.active {
      .info {
        color: #00b793;
      }
    }
  }
}

.member-summary {
  border-top: 1px solid #e0e0e0;
  span {
    color: #8c8786;
    font-size: 11px;
  }
}
.status-statistic {
  border-right: solid 1px #d8d6d9;
  h6 {
    font-size: 22px;
    font-weight: bold;
    &.active {
      color: #00b793;
    }
  }
}
.categories {
  .info {
    text-align: right;
  }
  .count {
    color: black;
    font-weight: bold;
  }
}

.group-category {
  background-color: #6e747a;
  color: rgb(243, 241, 241);
  font-size: 16px;
  font-weight: bold;
  overflow-x: auto;
}

.create-category {
  padding-left: 13px;
  padding-right: 13px;
  padding-top: 5px;
  padding-bottom: 80px;
}

.select-input {
  margin-top: 8px;
  font-size: 14px;
  font-weight: bold;
}

.submit-category {
  padding-top: 20px;
  text-align: right;
  right: 13px;
}
</style>
